import { render, staticRenderFns } from "./PeriodList.vue?vue&type=template&id=ae6f7934"
import script from "../../../controllers/custom/academic_period/period-list.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/academic_period/period-list.js?vue&type=script&lang=js&external"
import style0 from "./PeriodList.vue?vue&type=style&index=0&id=ae6f7934&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports